import { Reveal } from "../components/Reveal";
import { useLang } from "../lib/i18n";
import { IMAGES } from "../lib/content";

const initials = (name) =>
  name.split(" ").map((w) => w[0]).slice(0, 2).join("");

const PHOTOS = {
  "Isabella Rascon": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/22mhw5o6_Screenshot%202026-08-08%20at%2010.09.56%E2%80%AFPM.png", pos: "top" },
  "Megan Amaru": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/96qoiwv7_Screenshot%202026-08-08%20at%2010.10.26%E2%80%AFPM.png", pos: "top" },
  "Alessandra Rodriguez": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/1nm1wh62_Screenshot%202026-08-08%20at%2010.10.07%E2%80%AFPM.png", pos: "center 32%" },
  "Diana Murillo": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/ulsag30f_Screenshot%202026-08-08%20at%2010.09.29%E2%80%AFPM.png", pos: "center 20%" },
  "Sofia Heredia": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/wtrwyyxz_Screenshot%202026-08-09%20at%202.19.36%E2%80%AFPM.png", pos: "center 30%" },
  "Victoria Gutierrez": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/2aa2bwlw_Screenshot%202026-08-09%20at%202.20.21%E2%80%AFPM.png", pos: "center 18%" },
  "Camila McCord": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/pw77hgwh_Screenshot%202026-08-09%20at%202.20.50%E2%80%AFPM.png", pos: "center 22%" },
  "Ty Giggey": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/fw1aj9xk_Screenshot%202026-08-09%20at%202.21.24%E2%80%AFPM.png", pos: "center 30%" },
  "Anish Jagath": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/ivx90jtv_Screenshot%202026-08-09%20at%202.21.44%E2%80%AFPM.png", pos: "center 25%" },
  "Steven Anderson": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/czy0r70v_Screenshot%202026-08-09%20at%202.21.33%E2%80%AFPM.png", pos: "center 18%" },
  "Kyle Fitzgerald": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/bzxmncdv_Screenshot%202026-08-10%20at%201.00.17%E2%80%AFPM.png", pos: "center 20%" },
  "Eric Anderson": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/jku7y7iv_IMG_7449.webp", pos: "center 32%" },
  "Matt Zachek": { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/f00wax1g_Screenshot%202026-08-09%20at%204.36.09%E2%80%AFPM.png", pos: "center 12%" },
};

const MemberCard = ({ m, i, img }) => (
  <Reveal delay={(i % 4) * 0.06}>
    <div data-testid={`party-member-${m.name.toLowerCase().replace(/\s+/g, "-")}`}>
      {img ? (
        <img src={img.src} alt={m.name} loading="lazy" style={{ objectPosition: img.pos || "center" }} className="aspect-square w-full object-cover" />
      ) : (
        <div className="aspect-square w-full bg-[#EEF2E3] border border-[#DFE4D0] flex items-center justify-center">
          <span className="font-serif-display font-light text-5xl text-[#E15A70]">{initials(m.name)}</span>
        </div>
      )}
      <h3 className="font-serif-display text-xl sm:text-2xl font-medium mt-4">{m.name}</h3>
      <p className="text-[10px] uppercase tracking-[0.25em] text-[#465220] mt-1.5">{m.role}</p>
      {m.blurb && <p className="mt-2 text-sm font-light italic text-[#2C3552]/60">{m.blurb}</p>}
    </div>
  </Reveal>
);

export const WeddingParty = () => {
  const { c } = useLang();
  const p = c.party;
  return (
    <section id="party" className="py-28 sm:py-40 px-6" data-testid="party-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight">
            {p.title} <span className="italic text-[#465220]">{p.titleAccent}</span>
          </h2>
        </Reveal>

        <Reveal className="mt-16">
          <p className="font-serif-display italic text-2xl text-[#E15A70]">{p.herSide}</p>
        </Reveal>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12 mt-8">
          {p.her.map((m, i) => (
            <MemberCard key={m.name} m={m} i={i} img={PHOTOS[m.name]} />
          ))}
        </div>

        <Reveal className="mt-20">
          <p className="font-serif-display italic text-2xl text-[#465220]">{p.hisSide}</p>
        </Reveal>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12 mt-8">
          {p.him.map((m, i) => (
            <MemberCard key={m.name} m={m} i={i} img={PHOTOS[m.name]} />
          ))}
        </div>

        <div className="max-w-2xl mx-auto mt-24 grid grid-cols-2 gap-8 sm:gap-14 text-center">
          <Reveal>
            <div data-testid="party-member-alexa">
              <img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_sophisticated-day/artifacts/h74dqomw_IMG_4486.webp"
                alt="Alexa Rascon"
                loading="lazy"
                style={{ objectPosition: "center 35%" }}
                className="aspect-square w-full object-cover rounded-full"
              />
              <h3 className="font-serif-display text-2xl sm:text-3xl font-medium mt-5">{p.alexa.name}</h3>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#E15A70] mt-2">{p.alexa.role}</p>
              <p className="mt-3 text-sm font-light italic text-[#2C3552]/60">{p.alexa.blurb}</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div data-testid="party-member-bear">
              <img src={IMAGES.bearPortrait} alt="Bear" loading="lazy" className="aspect-square w-full object-cover object-top rounded-full" />
              <h3 className="font-serif-display text-2xl sm:text-3xl font-medium mt-5">{p.bear.name}</h3>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#E15A70] mt-2">{p.bear.role}</p>
              <p className="mt-3 text-sm font-light italic text-[#2C3552]/60">{p.bear.blurb}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
